// Identity API ile aynı değerler (Karsan.Dms.Model.MasterData.Identity.Permission.DataScope / UserType)

export const PERMISSION_ACTIONS = ['view', 'create', 'update', 'delete', 'approve', 'export'];

export const DATA_SCOPES = {
    OWN: 0,
    DEALER: 1,
    MAIN_DEALER: 2,
    REGION: 3,
    ALL: 4
};

export const DATA_SCOPE_KEYS = {
    0: 'own',
    1: 'dealer',
    2: 'mainDealer',
    3: 'region',
    4: 'all'
};

export const USER_TYPES = {
    KARSAN: 1,
    DEALER: 2
};

export const MODULE_ICONS = {
    warranty: 'pi pi-wrench',
    parts: 'pi pi-box',
    vehiclesales: 'pi pi-car',
    lms: 'pi pi-book',
    dealer: 'pi pi-building',
    finance: 'pi pi-wallet',
    quality: 'pi pi-shield',
    approval: 'pi pi-check-square',
    content: 'pi pi-file',
    admin: 'pi pi-cog'
};

// Eski (tek rollü) kullanıcı hesabı kaydı kullanım tipi ister; yeni ekranda seçilen modüllerden türetilir.
// DMS UserUsageTypeEnum: 1 Servis, 2 Satış (yedek parça), 3 Bayi, 4 Araç satış
export const resolveLegacyUsageType = (userType, moduleCodes = []) => {
    if (userType === USER_TYPES.KARSAN) return 3;
    if (moduleCodes.includes('warranty')) return 1;
    if (moduleCodes.includes('parts')) return 2;
    if (moduleCodes.includes('vehiclesales')) return 4;
    return 3;
};

export const permissionCode = (resourceCode, action) => `${resourceCode}.${action}`;
